export default "__VITE_ASSET__CIT9BF54__"